<template>
    <div class="text-center">
      <v-dialog dark v-model="dialog" width="800"> 

        <v-card>
        <v-card-title class="text-h5" style="background-color: #161d30;">
            <p class="text-center ma-0"> Detalles de la caja  </p>
        </v-card-title>

        <v-card-text style="background-color: #283045;"> 
            <p class="my-0"> <b>Fecha de apertura:</b> {{ cajita.fecha_apertura }} </p>
            <p class="my-0"> <b>Creado por:</b> {{ cajita.created_by }} </p>
            <p class="my-0"> <b>Monto de apertura:</b> {{ cajita.monto_apertura }} bs. </p>
            <p class="my-0"> <b>Monto de cierre:</b> {{ cajita.monto_cierre }} </p>
            <p class="my-0"> <b>Fecha de cierre:</b> {{ cajita.fecha_cierre }} </p>
            <p class="my-0"> <b>Actualizado por:</b> {{ cajita.updated_by }} </p>
            <p class="my-0"> <b>estado:</b> {{ cajita.estado?'activo':'inactivo' }} </p>

            <p class="mt-3 mb-0"> <b>Detalle de movimientos mientras la caja esta abierta:</b></p>
            <v-data-table :loading="loading" :headers="headers" :items="cajita.movimientos" disable-pagination hide-default-footer :items-per-page="5" class="elevation-1">
                <template v-slot:[`item.monto`]="{ item }">
                    <p class="my-0" style="min-width: 65px;"> Bs. {{ item.monto }} </p>
                </template> 
                <template v-slot:[`item.opt`]="{ item }">
                  <v-progress-linear v-if="loading_recibo" indeterminate color="green darken-2"></v-progress-linear>
                  <v-tooltip v-if="item.pago_inscripcion || item.recibo_antiguo" bottom>
                      <template #activator="{ on, attrs }">
                        <v-icon class="ma-2" v-bind="attrs" @click="showRecibo(item)" v-on="on" :color="item.pago_inscripcion?'light-blue':'orange'"
                          >mdi-eye</v-icon
                        >
                      </template>
                      Ver Recibo
                    </v-tooltip>
                </template>
            </v-data-table>

            <v-progress-linear v-if="loading" indeterminate color="green darken-2"></v-progress-linear>

            <div class="text-center pt-8">
                <v-btn :disabled="loading" :loading="loading" tile color="success" class="mr-4" @click="dialog =!dialog" > Ok </v-btn>
            </div>
        </v-card-text>  
      </v-card> 
      </v-dialog>

      <v-dialog v-model="dialog2" transition="dialog-bottom-transition" max-width="800">
        <v-card>
          <v-card-text>
            <iframe :src="base64pdf" width="100%" height="550"></iframe>
            <v-progress-linear v-if="!base64pdf" indeterminate/>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialog2 = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <ShowRecibo ref="refshowrecibo" />

    </div>
  </template>

<script> 
import xaxios from '@/xaxios';
import ShowRecibo from '../../recibos/Show.vue';
import gql from 'graphql-tag';

export default {
  data () {
    return {
      dialog2: false,
      dialog: false,
      valid: true,
      loading: false,
      loading_recibo: false,
      base64pdf: '',
      cajita: {id:'',movimientos:[]},
      headers:[
        { text: 'ID', value: 'id' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Detalle', value: 'detalle' },
        { text: 'Transaccion', value: 'transaccion' },
        { text: 'Monto', value: 'monto' },
        { text: 'Fecha', value: 'created_at' },
        { text: '', value: 'opt' },
      ]
    }
  }, 
  components:{ShowRecibo},  
  methods: {
    openmodal(data){
        this.dialog = true; 
        // window.console.log('data:::',data);
        this.cajita = {id:'',movimientos:[]};
        this.getData(data.id);
    },
    async showRecibo(item){
      if(item.recibo_antiguo){
        this.showReciboAntiguo(item);
        return;
      }
      const url = `${process.env.VUE_APP_API_REST}/api/pagos/recibos/buscar/inscripcion`;
      let formData = { 
        inscripcion_id: item.pago_inscripcion.inscripcion_id
      }
      this.loading_recibo = true;
      let res = await xaxios.post(url, formData).then(({ data }) => data);
      if(!res) res = [];
      let recibo = res.find(x=>x.id == item.pagos_inscripcion_id)
      this.$refs.refshowrecibo.showThisView(recibo);
      this.loading_recibo = false;
    },
    async showReciboAntiguo(item){ 
      this.loading_recibo = true;
      let sql = gql`query{getReciboById(id:${item.recibo_antiguo.id}){id,archivo_id}}`;
      let res = await this.$apollo.query({query: sql}).then((data) => data.data);
      window.console.log('resssss', res);
      this.cargarBase64File(res.getReciboById.archivo_id);
    },
    async cargarBase64File(archivo_id){
      this.base64pdf = ''; 
      let config = {
        method: 'get', 
        url: `${process.env.VUE_APP_SERVERFILES}${archivo_id}`, 
        headers: { 
          'Content-Type': 'application/json'
        }, 
      };

      this.dialog2 = true;
      let res = await xaxios.request(config).then((response) => response.data).catch((error) => error); 
      let b64 = `data:${res.mimetype};base64,${res.file64}`;
      this.base64pdf = b64;
      this.loading_recibo = false;
    }, 
    async getData(cajaid){
        this.loading = true;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/${cajaid}?detalle=true&recibos=true`
        const res = await xaxios.get(url).then(x=>x).catch(x=>x); 
        if(res && res.data){
            window.console.log('>>> res',res);
            this.cajita = res.data;
        }
        this.loading = false;
    }
  }
}
</script>